import { SocialNet } from '../interfaces/social-net';
import { SocialNetDto } from '../interfaces/social-net-dto';

export class SocialNetDataMapper {
  public decode(dto: SocialNetDto): SocialNet {
    return {
      id: dto.id,
      type: dto.type,
      url: dto.url,
    };
  }

  public decodeArray(dtos: SocialNetDto[]): SocialNet[] {
    if (!dtos || !dtos.length) {
      return [];
    }

    return dtos.map((dto) => this.decode(dto));
  }
}
